import React from 'react';
import MentalApi from '../../lib/MentalApi';
import PageNotFound from '../PageNotFound';
import LinkManager from '../../lib/LinkManager';
import UniversalLink from '../UniversalLink';

type Props = {
    what: string,
};

export default ({ what }: Props) => {
    const isLoggedIn = Boolean(MentalApi.getUserData());

    const aboLink = LinkManager.getAboLink();

    const title = isLoggedIn
        ? 'Dein Abo ist abgelaufen.'
        : `${what} nicht gefunden`;

    const message = isLoggedIn
        ? (
            <p>
                Wenn du weiterhin alle Inhalte von eleMental nutzen möchtest,&nbsp;
                kannst du dich &nbsp;
                <UniversalLink to={aboLink}>hier</UniversalLink>
                &nbsp;genauer informieren.
            </p>
        )
        : '';

    return (
        <PageNotFound
            title={title}
            message={message}
            showMentalIndexLink
        />
    );
};
